import { UserSelectors } from '@get/store/selectors';
import { SelectorModel } from '@get/utils';

// tslint:disable-next-line: variable-name
export const UserModel: SelectorModel = {
  name: 'users',
  getSelector: UserSelectors.selectAllUsersDictionary,
  isReady: UserSelectors.selectIsReadyUser
};
